import { createStructuredSelector } from 'reselect';
import { localeSelector, unitsSystemCodeSelector } from '@wxu/contexts/src/i18n/selectors';
import { preferredLocationGeocodeSelector } from '@wxu/contexts/src/preferred-location/selectors';

export const sunV3BaseUrlConfigParamsSelector = createStructuredSelector({
  geocode: preferredLocationGeocodeSelector,
  language: localeSelector,
  units: unitsSystemCodeSelector,
});
